import React, { useState, useRef, useEffect } from 'react';
import './CustomSelect.css';

const CustomSelect = ({ value, onChange, options, placeholder = "Select...", searchable = false }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const dropdownRef = useRef(null);
    const inputRef = useRef(null);

    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
                setSearchTerm('');
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const selectedOption = options.find(opt => opt.value === value);

    // Filter options based on search term
    const filteredOptions = searchable && searchTerm
        ? options.filter(opt =>
            opt.label.toLowerCase().includes(searchTerm.toLowerCase()))
        : options;

    const handleSearchChange = (e) => {
        setSearchTerm(e.target.value);
        setIsOpen(true);
    };

    const handleHeaderClick = () => {
        setIsOpen(!isOpen);
        if (searchable && !isOpen) {
            setTimeout(() => inputRef.current?.focus(), 100);
        }
    };

    return (
        <div className="custom-select" ref={dropdownRef}>
            <div
                className={`custom-select-header ${selectedOption ? 'has-value' : ''}`}
                onClick={handleHeaderClick}
            >
                {searchable && isOpen ? (
                    <input
                        ref={inputRef}
                        type="text"
                        value={searchTerm}
                        onChange={handleSearchChange}
                        placeholder={placeholder}
                        className="custom-select-search"
                        onClick={(e) => e.stopPropagation()}
                    />
                ) : (
                    <span className="custom-select-value">
                        {selectedOption?.icon && <span className="value-icon">{selectedOption.icon}</span>}
                        {selectedOption ? selectedOption.label : placeholder}
                    </span>
                )}
                {/* Show X when selected, otherwise show arrow */}
                {selectedOption ? (
                    <span
                        className="custom-select-clear"
                        onClick={(e) => {
                            e.stopPropagation();
                            onChange('');
                        }}
                        title="Clear"
                    >
                        ✕
                    </span>
                ) : (
                    <span className="custom-select-arrow">{isOpen ? '▲' : '▼'}</span>
                )}
            </div>

            {isOpen && (
                <div className="custom-select-dropdown">
                    {filteredOptions.map(option => (
                        <div
                            key={option.value}
                            className={`custom-select-option ${value === option.value ? 'selected' : ''} ${option.color || ''}`}
                            onClick={() => {
                                onChange(option.value);
                                setIsOpen(false);
                                setSearchTerm('');
                            }}
                        >
                            {option.icon && <span className="option-icon">{option.icon}</span>}
                            <span>{option.label}</span>
                        </div>
                    ))}
                    {filteredOptions.length === 0 && (
                        <div className="custom-select-option" style={{ color: '#888' }}>
                            No results found
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

export default CustomSelect;
